import React from "react";
import imagePng from "images/hero-right2.png";

const SectionHeroArchivePage = ({
  className = "",
  listingType,
  currentPage,
  // currentTab,
  rightImage = imagePng,
}) => {
  return (
    <div
      className={`nc-SectionHeroArchivePage flex flex-col relative ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      {/* Top row with heading and text */}
      <div className="w-full mb-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%] mb-6">
            Farmhouse and Wedding Lawn
          </h2>
          <h6 className="font-medium text-1xl md:text-1xl xl:text-2xl leading-[110%] mb-6">
            Available for Rent.
          </h6>
          <div className="flex items-center justify-center text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            <i className="text-2xl las la-map-marked"></i>
            <span className="ml-2.5">Hebsur </span>
            <span className="mx-5"></span>
            {listingType ? (
              listingType
            ) : (
              <>
                <i className="text-2xl las la-home"></i>
                <span className="ml-2.5">2 properties</span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Bottom row with image */}
      <div className="w-full">
        <img
          className="w-full h-auto rounded-2xl object-cover"
          src={"/svgs/main.jpg"}
          alt="hero"
        />
      </div>

      <div className="hidden lg:flow-root w-full">
        <div className="z-10 lg:-mt-40 xl:-mt-56 w-full">
          {/* <HeroSearchForm
          // currentPage={currentPage}
          // currentTab={currentTab}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default SectionHeroArchivePage;
